/**
 * How much of the menu is food and how much of it is drink.
 *
 * The line under the heading used to read "110 dishes", and a third of those were bottles:
 * the two wine lists are 34 of the 110. A guest counting plates should not be counting wine.
 *
 * Drinks are a category's `categoryType`, which is what the server sends for its BEVERAGE
 * categories and what the bundled backup marks its two wine lists with.
 */
export const isDrinks = (category) => category?.categoryType === "BEVERAGE";

export const countMenu = (categories) =>
    (Array.isArray(categories) ? categories : []).reduce(
        (tally, category) => {
            const items = category?.menuItems?.length || 0;
            return isDrinks(category)
                ? { ...tally, drinks: tally.drinks + items }
                : { ...tally, dishes: tally.dishes + items };
        },
        { dishes: 0, drinks: 0 }
    );
